import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "./InputError.css"

/**
 *
 * @param {{message: string, id: string}} param0
 * @returns
 */
export const InputError = ({ message, id }) => {
	if (message) {
		return (
			<div id={id} className="color-fg-danger f5 flex flex-items-center p-1 inputError">
				<FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" /> {message}
			</div>
		)
	}

	return null
}
